import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface FunnelData {
  label: string;
  value: number;
  percentage: number;
  cost: number;
}

interface FunnelChartProps {
  data: FunnelData[];
  title: string;
}

export function FunnelChart({ data, title }: FunnelChartProps) {
  const maxValue = Math.max(...data.map((d) => d.value));

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-base font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {data.map((item, index) => {
            const width = Math.max((item.value / maxValue) * 100, 15);
            const opacity = 1 - index * 0.15;

            return (
              <div key={item.label} className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="font-medium">{item.label}</span>
                  <div className="flex items-center gap-4 text-muted-foreground">
                    <span>{item.value.toLocaleString()}</span>
                    <span className="text-xs">({item.percentage.toFixed(1)}%)</span>
                  </div>
                </div>
                <div
                  className="h-8 rounded-md bg-primary transition-all duration-300"
                  style={{
                    width: `${width}%`,
                    opacity,
                  }}
                  data-testid={`funnel-bar-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
